var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3249 8.46823C17.3249 8.46823 16.7819 15.2032 16.4669 18.0402C16.3169 19.3952 15.4799 20.1892 14.1089 20.2142C11.4999 20.2612 8.88794 20.2642 6.27994 20.2092C4.96094 20.1822 4.13794 19.3782 3.99094 18.0472C3.67394 15.1852 3.13394 8.46823 3.13394 8.46823M18.7082 5.23973H1.75024M15.4406 5.23973C14.6556 5.23973 13.9796 4.68473 13.8256 3.91573L13.5826 2.69973C13.4326 2.13873 12.9246 1.75073 12.3456 1.75073H8.11264C7.53364 1.75073 7.02564 2.13873 6.87564 2.69973L6.63264 3.91573C6.47864 4.68473 5.80264 5.23973 5.01764 5.23973",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.a85e1237.svg";
export { ForwardRef as ReactComponent };